const featureData = [
  {
    id: 1,
    title: "Regular updates",
    subtitle: "Being a cloud-based system, you will get updates regularly",
    status: "Yes",
  }, {
    id: 14,
    title: "Unlimited call bundle",
    subtitle: "Unlimited calls to UK landlines and mobiles",
    status: "Yes",
  }, {
    id: 10,
    title: "Voice lines",
    subtitle: "Number of people that can be on the phone at the same time(s)",
    status: "Yes",
  }, {
    id: 2,
    title: "Welcome message",
    subtitle: "On hold message, music on hold, no answer, voicemail message",
    status: "Yes",
  }, {
    id: 3,
    title: "Voicemail to email",
    subtitle: "Voicemail messages can be delivered to an email address as a sound attachment",
    status: "Yes",
  }, {
    id: 4,
    title: "Voicemails",
    subtitle: "Corporate, main business voicemail",
    status: "Yes",
  }, {
    id: 5,
    title: "Work anywhere",
    subtitle: "Take your handset to any location and appear you are working from the office",
    status: "Yes",
  }, {
    id: 6,
    title: "Conference calling",
    subtitle: "Add multiple people to the same conversation",
    status: "Yes",
  }, {
    id: 7,
    title: "Re-route",
    subtitle: "Transfer calls to each office handsets or mobiles",
    status: "Yes",
  }, {
    id: 8,
    title: "Choice of DDIs",
    subtitle: "Choose from a local area code or an '03' number",
    status: "Yes",
  }, {
    id: 9,
    title: "Mobile twinning",
    subtitle: "Inbound calls can ring both on your telephone and mobile at the same time",
    status: "Yes",
  }, {
    id: 11,
    title: "Number porting",
    subtitle: "Transfer any existing number",
    status: "Yes",
  }, {
    id: 12,
    title: "Hot desking",
    subtitle: "Login to any handset in the office",
    status: "Yes",
  }, {
    id: 13,
    title: "Manage telephone system",
    subtitle: "Access to administration login and individual user login",
    status: "Yes",
  }, {
    id: 15,
    title: "HD call quality",
    status: "Yes",
  }, {
    id: 16,
    title: "Direct-Dials for each user",
    status: "Yes",
  }, {
    id: 17,
    title: "Do-not-disturb feature",
    status: "Yes",
  }, {
    id: 18,
    title: "Park calls",
    status: "Yes",
  }, {
    id: 19,
    title: "Call barging",
    status: "Yes",
  }, {
    id: 20,
    title: "Call whispering",
    status: "Yes",
  },
];
export default featureData;